import CitySEOHead from "@/components/feature/CitySEOHead";
import HeroSection from "./components/HeroSection";
import StickyNav from "./components/StickyNav";
import ProcessingTimeSection from "./components/ProcessingTimeSection";
import ServicesSection from "./components/ServicesSection";
import HowItWorksSection from "./components/HowItWorksSection";
import LocalAreaSection from "./components/LocalAreaSection";
import TestimonialsSection from "./components/TestimonialsSection";
import AcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import ComparisonSection from "./components/ComparisonSection";
import MistakesSection from "./components/MistakesSection";
import FAQSection, { faqs } from "./components/FAQSection";
import HelpfulResourcesSection from "./components/HelpfulResourcesSection";
import FinalCTA from "./components/FinalCTA";

const pageTitle = "Expedited & Emergency Passport Services Boise ID | Fast Passport Center";
const pageDescription = "Fast Passport Center provides emergency, expedited, and same-day passport services in Boise, Idaho. Serving Ada County, Meridian, Nampa, Eagle, and surrounding areas. As fast as 24 hours — no Seattle agency trip needed.";

export default function BoisePage() {
  return (
    <>
      <CitySEOHead
        city="Boise"
        state="Idaho"
        stateAbbr="ID"
        route="/cities/boise"
        title="Emergency Passport Boise"
        description={pageDescription}
        ogTitle={pageTitle}
        ogDescription={pageDescription}
        twitterTitle={pageTitle}
        twitterDescription={pageDescription}
        geoPlacename="Boise, Idaho"
        geoPosition="43.6150;-116.2023"
        keywords="expedited passport Boise, emergency passport Boise ID, same day passport Boise, fast passport Idaho, passport renewal Boise, Ada County passport"
        faqs={faqs}
        servicesSchema={[]}
        statePageName="Idaho"
        statePageRoute="/states/idaho"
        lastModified="2026-06-09"
        serviceAreaDesc="Expedited and emergency passport services for Boise, ID and Ada County. As fast as 24 hours. No Seattle agency trip needed."
      />

      <div className="min-h-screen bg-white">
      <HeroSection />
      <StickyNav />
      <ProcessingTimeSection />
      <LocalAreaSection />
      <ServicesSection />
      <HowItWorksSection />
      <TestimonialsSection />
      <AcceptanceFacilitiesSection />
      <ComparisonSection />
      <MistakesSection />
      <FAQSection />
      <HelpfulResourcesSection />
      <FinalCTA />
      </div>
    </>
  );
}